import React, { useMemo, useState } from "react";
import Section from "./Section";
import * as content from "../content";
import { formatGiftLines, getGiftEnv } from "../giftEnv";

export default function Gifts() {
  const { gifts: g } = content;
  const env = useMemo(() => getGiftEnv(), []);
  const lines = useMemo(() => formatGiftLines(env), [env]);
  const hasAny = lines.length > 0;
  const [copied, setCopied] = useState(false);

  const americanMailto = `mailto:${g.americanZelleEmail}?subject=${encodeURIComponent(
    g.americanZelleMailSubject
  )}`;

  const handleCopy = async () => {
    if (!lines) return;
    try {
      await navigator.clipboard.writeText(lines);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <Section id="gifts">
      <h2 className="section-title">{g.heading}</h2>
      <p className="prose">{g.intro}</p>
      <div className="registry-grid" role="group" aria-label="Cash registries">
        <div className="registry-card">
          <p className="prose muted registry-card__note">{g.koreanPlaceholder}</p>
          {env.registryKoreanUrl ? (
            <a
              className="button button--registry"
              href={env.registryKoreanUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {g.registryKoreanLabel}
            </a>
          ) : (
            <span className="button button--registry button--registry-muted" aria-disabled="true">
              {g.registryKoreanLabel}
            </span>
          )}
        </div>
        <div className="registry-card">
          <p className="prose registry-card__zelle">
            <strong>{g.labels.zelle}:</strong>{" "}
            <a href={americanMailto}>{g.americanZelleEmail}</a>
          </p>
          <a className="button button--registry" href={americanMailto}>
            {g.registryAmericanLabel}
          </a>
        </div>
      </div>
      {!hasAny ? (
        <p className="prose muted">{g.emptyMessage}</p>
      ) : (
        <dl className="gift-list">
          {env.zelle && (
            <>
              <dt>{g.labels.zelle}</dt>
              <dd>{env.zelle}</dd>
            </>
          )}
          {env.venmo && (
            <>
              <dt>{g.labels.venmo}</dt>
              <dd>{env.venmo}</dd>
            </>
          )}
          {env.paypal && (
            <>
              <dt>{g.labels.paypal}</dt>
              <dd>{env.paypal}</dd>
            </>
          )}
          {env.note && (
            <>
              <dt>{g.labels.note}</dt>
              <dd>{env.note}</dd>
            </>
          )}
        </dl>
      )}
      {hasAny && (
        <button type="button" className="button button--primary" onClick={handleCopy}>
          {copied ? g.copiedLabel : g.copyLabel}
        </button>
      )}
    </Section>
  );
}
